// Internal dependencies
import cloneDeep from 'lodash.clonedeep';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import merge from 'lodash.merge';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import ReactDOM from "react-dom";
import { withRouter } from 'react-router-dom';

// External dependencies
import DyslexiaRiskChart from '../../blocks/Charts/DyslexiaRisk';
import Loading from '../../../Global/Loading';
import PageStatus from '../../../Teacher/PageStatus';
import ClassWithNoStudents from '../../../Teacher/ErrorMessages/ClassWithNoStudents';
import Error from '../../../Teacher/Error';
import { states } from '../../values/enums';
import {isSpanishActivity} from "Services/API";
import {locales} from "Constants/constants";
import Legend from '../../../Teacher/Legend';
import { dyslexiaRiskLegendItems } from '../../../../constants/legend';

class DyslexiaRiskContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isScrolled: false,
      width: 0,
    };

    this.onChartScroll = this.onChartScroll.bind(this);
  }

  componentDidMount () {
    this.setState({
      width: ReactDOM.findDOMNode(this).offsetWidth,
    });
    this.props.initializeData();
    this.setState({sortReport: this.props.dyslexiaRiskSort});
  }


  filterByRisks(scores, risks){
    return scores.filter(s => {
      const isSpanish = isSpanishActivity(s);
      return isSpanish && risks.includes(locales.ES_MX) || !isSpanish && risks.includes(locales.EN_US);
    });
  }

  transformScores(scores){
    const studentScores = new Map();
    scores.forEach((item) => {
      const {studentId} = item;
      let score = {
        displayStatus: item.displayStatus,
        dyslexiaRiskCategory: item.dyslexiaRiskCategory,
        labeledScore: item.labeledScore,
        score: item.score,
        rawScore: item.rawScore,
        status: item.status,
        locale: item.locale = (item.tags && isSpanishActivity({tags: item.tags})) ? "ES" : "EN",
      };
      const student = studentScores.get(studentId);
      if (!student) {
        studentScores.set(studentId, {
          studentId: studentId,
          first_name: item.first_name,
          last_name: item.last_name,
          school: item.school,
          classroom: item.classroom,
          grade: item.grade,
          scores: [score],
          highestScore: item.score,
          highestRawScore: item.rawScore,
          activityDate: item.activityDate,
        });
      } else {
        student.scores.push(score);
        student.scores = student.scores.sort((a, b) => a.score > b.score);
        student.highestScore = student.scores[0].score;
        student.highestRawScore = student.scores[0].rawScore;
      }
    });

    return studentScores;
  }

  // conditionally enable scroll css styling
  onChartScroll(event) {
    let scrollTop = event.nativeEvent.srcElement.scrollTop;
    let isScrolled = (scrollTop > 8);

    if(isScrolled !== this.state.isScrolled) {
      this.setState({isScrolled: isScrolled})
    }
  }

  render () {
    let complete = cloneDeep(this.props.report);
    let reportStatus = this.props.reportStatus;

    // scroll styles
    const reportContainerStyles = cx({
     'reports-container': true,
     'dyslexiaRisk': true,
     'scrolled': this.state.isScrolled
    });
    const paddingContainerStyles = cx({
     'reports-dyslexiarisk-padding-container': true,
     'unscrolled': !this.state.isScrolled
    });

    let DyslexiaRiskContents;
    if(reportStatus && reportStatus.type === states.COMPLETE) {
      if(complete && complete.scores.length > 0) {
        complete.scores = this.transformScores(this.filterByRisks(complete.scores, this.props.selectedReadingRisks));
        DyslexiaRiskContents =
          <DyslexiaRiskChart
            report={complete}
            onScroll={this.onChartScroll}
            containerWidth={this.state.width}
          />;
      } else if(!this.props.students || (Array.isArray(this.props.students) && this.props.students.length == 0)){
        DyslexiaRiskContents = <ClassWithNoStudents />;
      } else {
        let equated = false;
        if(this.props.selectedMetric && this.props.selectedMetric.value == 'ORF' && this.props.selectedEquating) {
          equated = true;
        }
        DyslexiaRiskContents =
          <PageStatus
            isAggregateReport={true}
            viewText="scores as they relate to likelihood of dyslexia"
            equated={equated}
          />;
      }
    } else if(reportStatus && reportStatus.type === states.ERROR) {
      DyslexiaRiskContents = <Error />;
    } else {
      DyslexiaRiskContents = <Loading />;
    }

    return (
      <Fragment>
        <div className={reportContainerStyles}>
          <div className={paddingContainerStyles}>
            {DyslexiaRiskContents}
          </div>
        </div>
        <div className='dyslexia-legend-wrapper'>
          <Legend items={dyslexiaRiskLegendItems} />
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedMetric: get(state, 'reports.teacher.selections.metric', {}),
  selectedEquating: get(state, 'reports.teacher.equatingSelection', true),
  selectedLocale: get(state, 'reports.teacher.selectedLocale', true),
  selectedReadingRisks: get(state, 'reports.teacher.selectedReadingRisks', true),
  sorts: get(state, 'reports.dyslexia.sorts'),
  report: get(state, 'reports.dyslexia.report.data', null),
  reportStatus: get(state, 'reports.dyslexia.report.status', null),
});

DyslexiaRiskContainer.propTypes = {
  report: PropTypes.object,
  initializeData: PropTypes.func,
}

export default connect(mapStateToProps)(withRouter(DyslexiaRiskContainer))
